module.exports = __webpack_public_path__ + "static/media/jorisverwater.255d2b45.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jorisverwater.webp
// module id = 557
// module chunks = 0